import { render, staticRenderFns } from "./PremiumPurchasedModal.vue?vue&type=template&id=8171961c&scoped=true&"
import script from "./PremiumPurchasedModal.vue?vue&type=script&lang=js&"
export * from "./PremiumPurchasedModal.vue?vue&type=script&lang=js&"
import style0 from "./PremiumPurchasedModal.vue?vue&type=style&index=0&id=8171961c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8171961c",
  null
  
)

export default component.exports